var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,20,10)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.861,52.188C39.233,52.187 38.724,51.689 38.725,51.074L38.729,45.108C38.73,44.493 39.239,43.996 39.867,43.996C40.494,43.996 41.003,44.495 41.002,45.11L40.998,51.076C40.998,51.69 40.488,52.188 39.861,52.188Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.072,46.078C28.759,45.546 28.945,44.865 29.489,44.558L34.769,41.578C35.313,41.272 36.008,41.455 36.322,41.987C36.635,42.52 36.448,43.2 35.904,43.506L30.625,46.486C30.081,46.793 29.386,46.61 29.072,46.078Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.08,33.895C29.394,33.363 30.09,33.181 30.633,33.489L35.909,36.475C36.453,36.783 36.638,37.464 36.324,37.995C36.009,38.528 35.315,38.709 34.771,38.402L29.495,35.415C28.952,35.107 28.766,34.426 29.08,33.895Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.874,27.785C40.501,27.786 41.01,28.284 41.01,28.898L41.005,34.865C41.005,35.48 40.496,35.977 39.868,35.977C39.241,35.977 38.732,35.478 38.732,34.863L38.737,28.897C38.737,28.283 39.246,27.784 39.874,27.785Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.662,33.896C50.975,34.428 50.789,35.109 50.245,35.416L44.965,38.396C44.421,38.703 43.726,38.519 43.412,37.987C43.099,37.455 43.286,36.775 43.83,36.468L49.109,33.488C49.653,33.181 50.348,33.364 50.662,33.896Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.657,46.116C50.343,46.648 49.648,46.829 49.105,46.522L43.828,43.535C43.285,43.228 43.099,42.547 43.413,42.015C43.728,41.483 44.423,41.301 44.966,41.609L50.242,44.596C50.785,44.903 50.971,45.584 50.657,46.116Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.247,51.936C46.707,52.249 46.01,52.073 45.691,51.544L43.512,47.984C43.193,47.455 43.373,46.773 43.913,46.461C44.454,46.149 45.151,46.324 45.47,46.854L47.649,50.413C47.968,50.942 47.788,51.624 47.247,51.936Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.047,52.129C32.5,51.827 32.307,51.148 32.616,50.613L34.675,46.986C34.984,46.451 35.677,46.262 36.224,46.564C36.77,46.866 36.963,47.545 36.654,48.08L34.595,51.707C34.286,52.242 33.593,52.431 33.047,52.129Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.803,40.168C25.797,39.554 26.301,39.051 26.929,39.045L31.166,38.977C31.794,38.971 32.307,39.465 32.314,40.079C32.319,40.693 31.815,41.196 31.188,41.202L26.95,41.27C26.322,41.276 25.808,40.782 25.803,40.168Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.755,28.052C33.295,27.74 33.992,27.915 34.311,28.445L36.49,32.004C36.809,32.533 36.629,33.215 36.089,33.528C35.548,33.84 34.851,33.664 34.532,33.135L32.353,29.575C32.034,29.047 32.214,28.364 32.755,28.052Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.95,27.873C47.497,28.175 47.689,28.854 47.381,29.389L45.321,33.016C45.013,33.551 44.32,33.74 43.773,33.438C43.227,33.136 43.034,32.457 43.342,31.922L45.402,28.295C45.71,27.76 46.404,27.571 46.95,27.873Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.199,39.825C54.204,40.439 53.701,40.942 53.073,40.948L48.835,41.016C48.207,41.022 47.694,40.528 47.688,39.914C47.682,39.3 48.186,38.797 48.814,38.791L53.052,38.723C53.679,38.717 54.193,39.211 54.199,39.825Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.809,63.52C39.181,63.519 38.673,63.019 38.675,62.405L38.69,56.438C38.691,55.824 39.201,55.327 39.828,55.328C40.456,55.33 40.964,55.829 40.962,56.443L40.948,62.41C40.946,63.025 40.436,63.521 39.809,63.52Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.029,51.707C18.716,51.174 18.904,50.494 19.448,50.188L24.733,47.217C25.278,46.911 25.973,47.095 26.285,47.628C26.598,48.161 26.41,48.841 25.866,49.147L20.581,52.118C20.036,52.424 19.341,52.24 19.029,51.707Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.081,28.171C19.396,27.639 20.092,27.459 20.635,27.767L25.906,30.763C26.448,31.071 26.633,31.752 26.318,32.283C26.003,32.815 25.308,32.996 24.764,32.687L19.494,29.691C18.951,29.383 18.767,28.702 19.081,28.171Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.923,16.48C40.55,16.481 41.058,16.981 41.056,17.595L41.042,23.562C41.04,24.176 40.531,24.674 39.903,24.672C39.275,24.67 38.767,24.171 38.769,23.557L38.783,17.59C38.785,16.976 39.295,16.479 39.923,16.48Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.711,28.288C61.024,28.821 60.836,29.501 60.291,29.807L55.006,32.778C54.462,33.084 53.767,32.9 53.454,32.367C53.142,31.834 53.33,31.154 53.874,30.848L59.159,27.877C59.704,27.571 60.398,27.755 60.711,28.288Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.651,51.792C60.336,52.324 59.64,52.504 59.097,52.196L53.826,49.2C53.284,48.892 53.099,48.211 53.414,47.679C53.729,47.148 54.424,46.967 54.968,47.275L60.238,50.271C60.781,50.58 60.965,51.26 60.651,51.792Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.124,61.971C47.534,62.18 46.882,61.881 46.669,61.303L44.595,55.693C44.382,55.115 44.688,54.477 45.278,54.268C45.868,54.059 46.519,54.358 46.733,54.935L48.806,60.546C49.02,61.124 48.715,61.762 48.124,61.971Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.616,57.879C24.136,57.483 24.075,56.781 24.479,56.311L28.406,51.748C28.81,51.278 29.527,51.218 30.007,51.614C30.487,52.01 30.548,52.712 30.144,53.182L26.218,57.745C25.813,58.215 25.096,58.275 24.616,57.879Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.498,35.891C16.608,35.286 17.198,34.883 17.817,34.991L23.816,36.038C24.434,36.146 24.845,36.724 24.735,37.329C24.625,37.934 24.035,38.337 23.417,38.228L17.417,37.182C16.799,37.074 16.388,36.495 16.498,35.891Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.881,18.012C32.471,17.803 33.122,18.102 33.336,18.68L35.409,24.291C35.623,24.868 35.317,25.507 34.727,25.716C34.137,25.925 33.485,25.626 33.272,25.048L31.199,19.437C30.985,18.859 31.29,18.221 31.881,18.012Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.384,22.126C55.864,22.522 55.925,23.224 55.52,23.694L51.594,28.257C51.19,28.727 50.473,28.787 49.992,28.391C49.513,27.995 49.451,27.294 49.856,26.823L53.782,22.26C54.186,21.791 54.903,21.731 55.384,22.126Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.502,44.096C63.392,44.701 62.802,45.104 62.184,44.996L56.184,43.948C55.566,43.84 55.155,43.263 55.265,42.657C55.375,42.052 55.965,41.65 56.583,41.758L62.583,42.805C63.201,42.913 63.613,43.491 63.502,44.096Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.765,57.33C55.297,57.739 54.578,57.698 54.16,57.239L50.106,52.784C49.689,52.325 49.731,51.621 50.199,51.213C50.669,50.804 51.387,50.845 51.804,51.304L55.858,55.759C56.275,56.218 56.234,56.921 55.765,57.33Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.558,62.035C31.962,61.842 31.638,61.213 31.836,60.629L33.75,54.964C33.947,54.381 34.59,54.065 35.186,54.257C35.782,54.451 36.105,55.08 35.908,55.663L33.994,61.328C33.797,61.911 33.154,62.227 32.558,62.035Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.785,44.683C16.658,44.081 17.053,43.492 17.667,43.368L23.635,42.158C24.25,42.034 24.852,42.421 24.979,43.023C25.106,43.624 24.711,44.213 24.096,44.338L18.128,45.547C17.513,45.672 16.912,45.284 16.785,44.683Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.233,22.653C24.701,22.244 25.42,22.285 25.837,22.744L29.891,27.199C30.309,27.658 30.267,28.362 29.798,28.77C29.329,29.179 28.611,29.138 28.194,28.679L24.14,24.224C23.722,23.765 23.764,23.062 24.233,22.653Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.446,17.974C48.042,18.167 48.365,18.796 48.168,19.38L46.254,25.045C46.057,25.627 45.414,25.944 44.818,25.751C44.222,25.558 43.899,24.928 44.096,24.345L46.01,18.68C46.207,18.098 46.85,17.781 47.446,17.974Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.213,35.296C63.34,35.898 62.945,36.487 62.331,36.611L56.362,37.821C55.748,37.945 55.146,37.558 55.019,36.956C54.892,36.355 55.287,35.766 55.902,35.641L61.87,34.432C62.484,34.307 63.086,34.695 63.213,35.296Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5,40C79.5,18.199 61.801,0.5 40,0.5C18.199,0.5 0.5,18.199 0.5,40C0.5,61.801 18.199,79.5 40,79.5C61.801,79.5 79.5,61.801 79.5,40Z",
    style: {
      fill: "none",
      stroke: "rgb(232,237,240)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeMiterlimit: 4
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRma);
export default __webpack_public_path__ + "static/media/rma.912fa584.svg";
export { ForwardRef as ReactComponent };